
<template>
  <div class="overview">
    <div class="overview-container">
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :width="item.width"
          />
          <el-table-column label="风险评分" min-width="150">
            <template slot-scope="scope">
              <div>
                {{scope.row.riskScore}}
                <el-tooltip effect="dark" content="有新的任务完成，评分可能发生变化" placement="right" v-if="scope.row.status == 1">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button  type="text" class="btn-text" @click="riskScore(scope.row.id)"
                >风险评分</el-button
              >
              <el-button  type="text" class="btn-text" @click="taskRecord(scope.row.id)"
                >任务记录</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-tpl-container">
          <pagination-tpl
            :total="totalNum"
            :currentPage="currentPage"
            @queryChange="onQueryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>

    <!-- 风险评分 -->
    <el-dialog
      title="风险评分"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
      >
        <el-form-item label="填写评分" prop="riskScore">
          <el-input class="gray white" v-model="form.riskScore" 
              @input="
                inputAmount(
                  form.riskScore
                )"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "@/components/PaginationTpl.vue";
import { inputAllTwoDecimal, handleAmount } from "@/common/js/utils.js";
import Risk from "@/models/risk.js";
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      tableData: [],
      teamId: '',
      totalNum: 0,
      currentPage: 1,
      tableTitleList: [
        {prop: 'deptName', lable: '单位名称', width: ''},
      ],
      dialogVisible: false,
      form: {
        riskScore: '',
      },
      rules: {
        riskScore: [{ required: true, message: "请输入评分", trigger: "blur" }],
      },
    }
  },

  created() {
    this.initTableList()
  },

  methods: {
    initTableList() {
      let data = {}
      data.pageNo = this.currentPage
      Risk.getRiskOverviewList(data).then(res => {
        if (res.success) {
          let arr = []
          this.totalNum = res.result.totalNum
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.teamId
            obj.deptName = i.teamName
            obj.riskScore = handleAmount(i.point,2)
            obj.status = i.remindFlag
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    
    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initTableList();
    },

    riskScore(id) {
      this.teamId = id
      this.dialogVisible = true
    },

    taskRecord(id) {
      this.$router.push({
        path: '/oneLevel/riskModuleIndex/overviewIndex/taskRecord',
        query: {
          teamId: id
        }
      })
    },
    
    /* 限制自定义金额为两位小数 */
    inputAmount(v) {
      this.form.riskScore = inputAllTwoDecimal(v);
    },

    handleClose() {
      this.form.riskScore = ''
      this.dialogVisible = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveRiskScore()
          this.handleClose()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    saveRiskScore() {
      let data = {
        teamId: this.teamId,
        point: handleAmount(this.form.riskScore,1)
      }
      Risk.postSavePoints(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '保存成功'
          });
          this.initTableList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
  }
}
</script>

<style lang='scss'>
.overview {
  flex: 1;
  padding: 20px;
  background: $bg-white;
  .overview-container {
    height: 100%;
  }
  .el-icon-warning {
    color: $medium-risk;
  }
}
</style>
